import { useEffect } from "react";
import { Helmet } from "react-helmet";
import Loading from '../sections/loading/loading';
import { GetAuth } from "../context/auth/authProvider";
import { useNavigate } from "react-router-dom";

const LandingPage = () => {

    <Helmet>
        <title>Home</title>
    </Helmet>

    const authState = GetAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if(authState.currentUser){
            navigate('/records');
        }
        else{
            navigate('/login');
        }
    }, [authState.currentUser]);

    return(
        <>
            <Loading />
        </>
    );
}

export default LandingPage;